import { fetchGetAnnouncement } from '@/services';
import type { AnyObj, AnyObjOrNull } from '@/types';
import { toast } from '@/utils';
import { defineStore } from 'pinia';

interface State {
  /** 通告数据 */
  announcementData: AnyObjOrNull;
  homeCustomId: string; //首页自定义页面id
  classifyCustomId: string; //所有商品页自定义页面id
  activityCustomId: string; //活动页自定义页面id
}

export const useCustomStore = defineStore('custom', {
  state: (): State => ({
    announcementData: null,
    homeCustomId: '',
    classifyCustomId: '',
    activityCustomId: '',
  }),
  getters: {},
  actions: {
    async getAnnouncement(refresh?: boolean) {
      if (!this.announcementData || refresh) {
        const data = await fetchGetAnnouncement();
        this.announcementData = data;
      }
      return this.announcementData;
    },
    async commonGetDataHandler(callback: () => Promise<void>) {
      const cancelLoading = toast.loading();
      await callback();
      cancelLoading();
    },
  },
});
